// 舞台参数
export const DEFAULT_STAGE_OPTION = {
  masker: {
    fill: '#000',
    opacity: 0.6,
    x: 0,
    y: 0,
  }
}

// 点线模式常规数据 可以根据传入参数被覆盖
export const DEFAULT_LINE_OPTION = {
  // 点
  pointer: {
    radius: 6,
    fill: '#fff',
    stroke: '#44A1F2',
    strokeWidth: 2,
    zIndex: 2
  },
  // 线
  line: {
    stroke: '#44A1F2',
    tension: 1,
    hitStrokeWidth: 15,
    zIndex: 0
  },
  // 灯
  lamp: {
    radius: 4,
    fill: '#44A1F2',
    zIndex: 1
  }
}

// 点线模式常规数据 可以根据传入参数被覆盖
export const DEFAULT_CIRCLE_OPTION = {
  // 圆
  circle: {
    stroke: '#44A1F2',
    strokeWidth: 2,
    zIndex: 1,
    hitStrokeWidth: 15,
    fillEnabled: false
  },
  // 点
  pointer: {
    radius: 6,
    fill: '#fff',
    stroke: '#44A1F2',
    strokeWidth: 2,
    zIndex: 1
  },
  // 灯
  lamp: {
    radius: 4,
    fill: '#44A1F2',
    zIndex: 2
  }
}

// 按钮配置
export const BTN_LIST_OPTION = {
  draw: {
    isShow: true,
    key: 'draw',
    text: '绘制路径',
  },
  edit: {
    isShow: true,
    key: 'edit',
    text: '编辑路径',
  },
  delete: {
    isShow: true,
    key: 'delete',
    text: '删除路径',
  },
  deleteLast: {
    isShow: true,
    key: 'deleteLast',
    text: '回撤路径',
  },
  css: `
    .draw-canvas_btn-list { display: flex; align-items: center; justify-content: center; width: 100%; padding: 8px 0; background: #1146AA; }
    .draw-canvas_btn-list_container { display: flex; aligin-item: center; }
    .draw-canvas_btn { width: 70px; background: #0044a8; color: #fff; border-radius: 4px; margin-right: 10px }
    .draw-canvas_btn.active { background: #0B3687; }
    .draw-canvas_btn p { padding-top: 5px; text-align: center; }
    .rect {background: url("~@/assets/img/visual/tool-rect@2x.png") no-repeat 0 0 / 100% 100%;}
  `
}